import { render } from "./waterFilterAndTreatment.vue?vue&type=template&id=ac3b7348&scoped=true"
import script from "./waterFilterAndTreatment.vue?vue&type=script&lang=js"
export * from "./waterFilterAndTreatment.vue?vue&type=script&lang=js"

import "./waterFilterAndTreatment.vue?vue&type=style&index=0&id=ac3b7348&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac3b7348"]])

export default __exports__